<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="领券记录" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.member_id" filterable remote placeholder="按会员手机号搜索" :remote-method="searchMember" clearable style="width: 100%">
            <el-option v-for="m in memberOptions" :key="m.member.id" :label="(m.customer ? m.customer.name : '') + ' ' + (m.customer ? m.customer.phone : '')" :value="m.member.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="未使用" value="未使用"></el-option>
            <el-option label="已使用" value="已使用"></el-option>
            <el-option label="已过期" value="已过期"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">会员领券</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="会员ID" prop="memberId" width="100"></el-table-column>
        <el-table-column label="券模板ID" prop="couponId" width="100"></el-table-column>
        <el-table-column label="领取时间" prop="getTime" width="160"></el-table-column>
        <el-table-column label="使用时间" prop="useTime" width="160"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已使用' ? 'info' : 'success'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button size="mini" type="success" v-if="scope.row.status === '未使用'" @click="use(scope.row)">核销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="会员领券" :visible.sync="show" width="480px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="会员" required>
          <el-select v-model="form.member_id" filterable remote placeholder="输入手机号搜索" :remote-method="searchMember" style="width: 100%">
            <el-option v-for="m in memberOptions" :key="m.member.id" :label="(m.customer ? m.customer.name : '') + ' ' + (m.customer ? m.customer.phone : '')" :value="m.member.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券" required>
          <el-select v-model="form.coupon_id" style="width: 100%">
            <el-option v-for="c in coupons" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, member_id: null, status: '' },
      list: [],
      total: 0,
      show: false,
      form: { member_id: null, coupon_id: null },
      memberOptions: [],
      coupons: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/coupons', { params: { page: 1, limit: 100, status: 1 } }).then(r => {
      if (r.data.status === 200) this.coupons = r.data.data.records || []
    })
  },
  methods: {
    getData () {
      this.$axios.get('/memberCoupons', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchMember (kw) {
      if (!kw) return
      this.$axios.http.get('/members', { params: { page: 1, limit: 20, keyword: kw } }).then(r => {
        if (r.data.status === 200) this.memberOptions = r.data.data.records || []
      })
    },
    add () {
      this.form = { member_id: null, coupon_id: null }
      this.show = true
    },
    save () {
      if (!this.form.member_id || !this.form.coupon_id) { this.$message.warning('请选择会员和优惠券'); return }
      this.$axios.post('/memberCoupons', () => { this.show = false; this.getData() }, this.form)
    },
    use (row) {
      this.$prompt('关联收费单ID', '核销', { inputPattern: /^\d+$/, inputErrorMessage: '请输入数字ID' }).then(({ value }) => {
        this.$axios.put(`/memberCoupons/${row.id}/use`, () => this.getData(), { use_charge_id: value })
      }).catch(() => {})
    }
  }
}
</script>
